import React from 'react';
import Card from '../../../../ui/Card';
import { Tabs } from '../../../../ui/Tabs';
import type { Floorplan, Unit } from '../UnitTable';
import * as styles from './unitDetailOverlay.styles';

type LayoutSectionProps = {
  unit: Unit;
  floorplan: Floorplan;
};

const LAYOUT_TABS = [{ id: 'floorplan', label: 'Floor Plan' }];

export const LayoutSection = ({ unit, floorplan }: LayoutSectionProps) => {
  // Only show actual floor plan layout images, not unit interior photos
  const layoutCount = floorplan.layoutCount ?? 0;
  const imageUrl = layoutCount > 0 ? (floorplan.largePhotos?.[0]?.url ?? floorplan.photos?.[0]?.url ?? null) : null;

  if (!imageUrl) {
    return null;
  }

  return (
    <section>
      <Card variant="default" size="md" title="The layout">
        <Tabs
          tabs={LAYOUT_TABS}
          activeTabId="floorplan"
          onTabChange={() => {}}
          ariaLabel="Layout views"
          idPrefix="layout-tab"
        />

        <img src={imageUrl} alt={`Floor plan for unit ${unit.name}`} className={styles.floorPlanImage} loading="lazy" />

        <div className={styles.unitSpecs}>
          <span className={styles.specItem}>
            <span className={styles.specValue}>{unit.beds}</span> Beds
          </span>
          <span className={styles.specItem}>
            <span className={styles.specValue}>{unit.baths}</span> Baths
          </span>
          <span className={styles.specItem}>
            <span className={styles.specValue}>{unit.sqft.toLocaleString('en-US')}</span> sqft
          </span>
        </div>
      </Card>
    </section>
  );
};
